export default __webpack_public_path__ + "static/media/coinmarket-icon.e17bb649.png";